import { Transform, Type } from 'class-transformer';
import {
  IsArray,
  IsDateString,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsPositive,
  IsString,
  ValidateNested,
} from 'class-validator';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';
import { LotAllergenDto } from './lot-allergen.dto';

export class CreateLotDto {
  @IsString()
  @IsNotEmpty()
  name!: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  description?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  notes?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  recipeName?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  supplierLot?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  supplierName?: string;

  @IsString()
  @IsOptional()
  @OptionalStringTransform()
  measurementUnit?: string;

  /** Quantità del lotto nell'unità `measurementUnit`. Richiede un'unità di misura valorizzata. */
  @IsOptional()
  @IsNumber({ maxDecimalPlaces: 2 }, { message: 'error.lot.invalidQuantity' })
  @IsPositive({ message: 'error.lot.invalidQuantity' })
  quantity?: number | null;

  @IsDateString()
  @IsOptional()
  @Transform(({ value }) => {
    if (value instanceof Date) {
      return value.toISOString().split('T')[0];
    }
    return value;
  })
  productionDate?: string;

  @IsDateString()
  @IsNotEmpty()
  @Transform(({ value }) => {
    if (value instanceof Date) {
      return value.toISOString().split('T')[0];
    }
    return value;
  })
  expiryDate!: string;

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => LotAllergenDto)
  allergens?: LotAllergenDto[];
}
